<!--
    Desarrollado por: Ing. Wuilmer garcia
    // Fecha: 2021/04/04
    // Modificado por: 
    // Fecha de ultima Modificacion:    
    // Causa: 

    ///////////////////////////////////////////////////////////
-->

<template>
    <div>
        <!-- formulario del Perfil -->

        <v-form ref="formDatos" lazy-validation> 
            <v-dialog v-model="estadoComp" persistent scrollable max-width="50%">
                <v-card>
                    <v-card-title class="modal_title">
                        <v-row class="d-flex justify-space-between py-2"> 
                            {{ formTitle }}
                            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title> 

                    <v-divider></v-divider>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-text-field v-model="Datos.desc_noticia_categoria" label="Nombre" :rules="[validation.required, validation.max100]"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" class="py-0">
                                <v-radio-group v-model="Datos.estado_noticia_categoria" label="Estado" row>
                                    <v-radio :label="`Activo`" :value="true" color="teal"></v-radio>
                                    <v-radio :label="`Inactivo`" :value="false" color="error"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="btn_style3" :disabled="disabledButton" tile @click="$emit('close')">Cancelar</v-btn>
                        <v-btn class="btn_block_style2" :disabled="disabledButton"  :loading="loading" tile @click="saveItem">{{saveText}}</v-btn>
 

                    </v-card-actions>

                        <span v-if="test">
                            <code>parametros :{{parametros}} </code> 
                            <code>Datos:  {{Datos}} </code>
                        </span>
                     </v-card>
               
            </v-dialog>


           
        </v-form>

        <!-- fin modal del Colegio -->



    </div>
</template>

<script>

    import axios from "@/helpers/axios";
    import { validation } from "@/helpers/validator.js";
    import {mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        name:'NoticiaCategoriaFormulario',

        // props:['estadoComp' , 'parametros'],
        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },



        data(){
            return{
                session: sessionStorage,
                test:false,
                Datos: [],
                saveText : "undefined",
                disabledButton: false,
                loading:false,
               
                

            }
        },
       
        mounted() {  
             this.loadMain()
        },

        //computadas
        computed: {
         
            ...mapGetters('login', [ 'componenteEvento']),
           
            formTitle () {
                return this.parametros.evento === 'agregar' ? 'Crear Categoria' : 'Editar Categoria'
            },

            validation() {
                return validation;
            },

                   
        },

        
        
        watch: {
            // cada vez que la pregunta cambie, esta función será ejecutada
            estadoComp() {
                if(this.estadoComp){
                    this.loadMain()                    
                }else{   
                    //this.parametros = {}
                    this.limpiarForm()
                 
                }
            }
        },
        

        methods: {

            ...mapActions('login',['parametroComponente'] ),
            ...mapMutations('mensajeSis', ['setEnviarMens']),


            loadMain(){

                this.limpiarForm() 
                // this.$refs.formDatos.resetValidation()
                if(this.parametros.evento=='agregar'){
                    this.saveText = "Guardar"                    
                }
                
                if(this.parametros.evento=='editar'){
                    this.saveText = "Guardar Cambios"
                    this.editItem(this.parametros.item) 
                }

            },

        
            editItem (item) {                
                this.Datos  =item        
            },



            limpiarForm(){
                this.Datos = {id_usuario: this.session.id, id_empresa: this.session.id_empresa,
                                   id:0, desc_noticia_categoria: '',  estado_noticia_categoria:true
            }

                this.resetValidation()
            },

            // Validar resetear campos al guardar
            resetValidation() {
                this.$refs.formDatos.resetValidation()
            },





             // Guarda los Perfiles
            async saveItem(){
                if (this.$refs.formDatos.validate()) {
                    try{
                        this.disabledButton = true
                        this.loading =true
               
                        if(this.parametros.evento == "agregar"){
                           await axios.post("/website/notCategoria",this.Datos)
                            this.setEnviarMens({tipo:"S", mensaje: `Registro guardado con éxito`, tiempo:null})
                        }

                        if(this.parametros.evento == "editar"){
                            await axios.put("/website/notCategoria/"+this.Datos.id,this.Datos)
                            this.setEnviarMens({tipo:"S", mensaje: `Registro guardado con éxito`, tiempo:null})
                        }

                        this.limpiarForm()
                        this.disabledButton = false
                        this.loading =false
                        this.$emit('reloadComp','docCategoria')
                    }

                    catch(e){
                        if (e.response) {
                            let resp = e.response.data
                            console.log(resp)
                            this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                        }
                    }
                }
            },

          

        },
    }
</script>


<style scoped>
</style>